<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="8" class="search-nav-left">
          <span style="margin-left: 10px;" :title="editSingleNameShow" v-show="showSingleName === false" class="order-list-search-span analyse-edit-name">{{ tmpName }}</span>
          <el-input style="margin-left: 10px;" :maxlength="20" v-show="showSingleName" class="board-stockInput" type="text" v-model="daBoardName" auto-complete="off" placeholder=""></el-input>
          <img v-show="showSingleName === false" style="cursor: pointer;width: 14px;height: 14px;margin-top: 17px;margin-left: 10px" src="../../assets/images/icn-binaji.png" class="analyse-edit-name-btn" @click="openEditName"/>
          <i @click="saveSingleNameOnly" v-show="showSingleName" class="el-icon-circle-check-outline" style="color: #1980FF!important;font-size: 16px!important;cursor: pointer;margin-left: 0"></i>
        </el-col>
        <el-col :span="16" class="search-nav-right">
          <el-button class="search-btn-new" type="primary" size="small" @click="saveDashBoardAction(1)">保存看板</el-button>
          <el-button style="margin-right: 16px;" class="search-btn-new" type="primary" size="small" @click="saveAnotherBoardDialog = true">另存看板</el-button>
          <el-button style="margin-right: 16px;" class="search-btn-new" type="primary" size="small" @click="confirmSingleAction">添加单图</el-button>
          <el-button style="margin-right: 16px;" class="search-btn-new" type="primary" size="small" @click="addSingleChartAction">选择单图</el-button>
        </el-col>
      </el-row>
        <div class="middle">
          <grid-layout
            :layout="layout"
            :auto-size="true"
            :col-num="20"
            :row-height="50"
            :max-rows="100"
            :is-draggable="true"
            :is-resizable="true"
            :vertical-compact="true"
            :is-mirrored="false"
            :margin="[10, 10]"
            :use-css-transforms="true">
            <grid-item v-for="item in layout" :key="item.i"
              :min-w="6"
              :min-h="6"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
              :heightFromChildren="true"
              @resize="resizeEvent"
              @move="moveEvent"
              @resized="resizedEvent"
              @moved="movedEvent"
              v-loading="loading"
              style="border: 1px solid #E8E8E8;">
              <template v-for="(one, key) in chartObject">
              <div
                class="item-content"
                v-if="item.i === one.figureId"
                :key="key"
                style="display: flex; justify-content: flex-start; flex-direction: column; position: relative;height: 100%; width: 100%;">
                <el-row style="height: 45px;">
                  <el-col :span="20" class="text-align-right">
                    <div class="chart-title">{{ one.figureName }}</div>
                  </el-col>
                  <el-col :span="4" class="text-align-right">
                    <div class="button-content">
                      <i
                      class="iconfont icon-icon-test10 analyse-icon"
                      @click="deleteSingleChart(one)">
                    </i>
                    <i
                      class="iconfont icon-icon-test9 analyse-icon"
                      @click="pushToPage(item)">
                    </i>
                    <el-dropdown style="margin-right: 15px;">
                      <span class="el-dropdown-link">
                        <i class="iconfont icon-icon-test16 analyse-icon"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <!--表格-->
                        <el-dropdown-item
                          @click.native="chooseTable('table', item, one)"
                          :disabled="one.hasTable === 0 ? true : false">
                          <i
                            :class="(item.showType === '' ? (one.defaultShow === 'table') : (item.showType === 'table')) ? 'icon-blue' : 'icon-black'" class="analyse-res-icon iconfont icon-wenbenjieguo-1">
                          </i>
                        </el-dropdown-item>
                        <!--饼-->
                        <el-dropdown-item
                          @click.native="choosePie('pieChart', item, one)"
                          :disabled="one.hasPieChart === 0 ? true : false">
                          <i
                            :class="(item.showType === '' ? (one.defaultShow === 'pieChart') : (item.showType === 'pieChart')) ? 'icon-blue' : 'icon-black'"
                            class="analyse-res-icon icon-bingzhuangtu-1 iconfont">
                          </i>
                        </el-dropdown-item>
                        <!--线-->
                        <el-dropdown-item
                          @click.native="chooseLine('lineChart', item, one)"
                          :disabled="one.hasLineChart === 0 ? true : false">
                          <i :class="(item.showType === '' ? (one.defaultShow === 'lineChart') : (item.showType === 'lineChart')) ? 'icon-blue' : 'icon-black'" class="analyse-res-icon icon-zhexiantu- iconfont">
                          </i>
                        </el-dropdown-item>
                        <!--柱-->
                        <el-dropdown-item
                          @click.native="chooseZhu('barGraph', item, one)"
                          :disabled="one.hasBarGraph === 0 ? true : false">
                          <i :class="(item.showType === '' ? (one.defaultShow === 'barGraph') : (item.showType === 'barGraph')) ? 'icon-blue' : 'icon-black'"
                            class="iconfont icon-zhuzhuangjieguo-1 analyse-res-icon">
                          </i>
                        </el-dropdown-item>
                        <!--数字-->
                        <el-dropdown-item
                          @click.native="chooseNum('singleMetric', item, one)"
                          :disabled="one.hasSingleMetric === 0 ? true : false">
                          <i class="iconfont icon-shuzijieguo-1 analyse-res-icon"  :class="(item.showType === '' ? (one.defaultShow === 'singleMetric') : (item.showType === 'singleMetric')) ? 'icon-blue' : 'icon-black'">
                          </i>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    </div>
                  </el-col>
                </el-row>
                  <div v-if="(one.hasTable === 1 && item.showType === 'table') || (one.hasTable === 1 && item.showType === '' && one.defaultShow === 'table')" class="table-div">
                    <a-locale-provider :locale="zhCN">
                    <a-table
                            class="board-table"
                            :pagination="{
                          total: one.tableData.total,
                          defaultCurrent: page,
                          pageSize: 6,
                          showQuickJumper: true,
                          showSizeChanger: false,
                          showTotal: function (total) { // 设置显示一共几条数据
                            return '共 ' + total + ' 条数据'
                          }
                        }"
                            :columns="one.tableData.columns"
                            :dataSource="one.tableData.tableData">
                    </a-table>
                  </a-locale-provider>
                  </div>
                  <div class="result-number" v-show="(one.hasSingleMetric === 1 && item.showType === 'singleMetric') || (one.hasSingleMetric === 1 && item.showType === '' && one.defaultShow === 'singleMetric')" :ref="'metricContent' + one.figureId">
                    <span>{{ one.singleMetric }}</span>
                  </div>
                  <!--柱状图-->
                  <div class="chart-content" v-show="(one.hasBarGraph === 1 && item.showType === 'barGraph') || (one.hasBarGraph === 1 && item.showType === '' && one.defaultShow === 'barGraph')" :ref="'barContent' + one.figureId">
                    <div :ref="'barChart' + one.figureId" class="chart1"></div>
                  </div>
                  <!--折线图-->
                  <div class="chart-content" v-show="(one.hasLineChart === 1 && item.showType === 'lineChart')  || (one.hasLineChart === 1 && item.showType === '' && one.defaultShow === 'lineChart')" :ref="'lineContent' + one.figureId">
                    <div :ref="'chartLine' + one.figureId" class="chart1"></div>
                  </div>
                  <!--饼图-->
                  <div class="chart-content" v-show="one.hasPieChart === 1 && item.showType === 'pieChart'|| (one.hasPieChart === 1 && item.showType === '' && one.defaultShow === 'pieChart')" :ref="'pieContent' + one.figureId">
                    <div :ref="'chartPie' + one.figureId" class="chart1"></div>
                  </div>
              </div>
              </template>
            </grid-item>
          </grid-layout>
        </div>
    </div>
    <el-dialog
      title="另存看板"
      :visible.sync="saveAnotherBoardDialog"
      width="520px"
      class="cellDialog">
      <el-form :model="saveAnotherBoardForm" label-width="110px"  ref="saveAnotherBoardForm" :rules="rules" >
        <el-form-item label="看板名称" prop="name">
          <el-input v-model="saveAnotherBoardForm.name" placeholder="请输入看板名称(20字以内)" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" style="margin-right: 20px" @click="saveAnotherBoardDialog = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 20px" @click="submitSaveAnotherBoardForm('saveAnotherBoardForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { Table, LocaleProvider } from 'ant-design-vue'
import { saveAnotherDashBoard, addSingleChartToDashBoard, getSingleChartDashBoard, modifyDashBoardTitle, deleteSingleChartFromeDashBoard, updateDashBoard, getSingleChartDetails, getDashBoardList, addDashBoard, deleteDashboard, getDashBoardSingleChartList } from '@/api/analyse.js'
import { mapMutations, mapGetters } from 'vuex'
import VueGridLayout from 'vue-grid-layout'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
Vue.use(VueGridLayout)
var GridLayout = VueGridLayout.GridLayout
var GridItem = VueGridLayout.GridItem

export default {
  name: 'boardDetails',
  data() {
    return {
      tmpName: '',
      selectSingleDialog: false,
      selectSingleChartAction: false,
      editSingleNameShow: false,
      showSingleName: false,
      myStorage: window.localStorage,
      selectType: 1,
      addSingleDialog: false,
      zhCN,
      totalCount: 0,
      page: 1,
      limit: 5,
      total: 0,
      columns: [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name'
        }, {
          title: 'Age',
          dataIndex: 'age',
          key: 'age',
          width: '12%'
        }, {
          title: 'Address',
          dataIndex: 'address',
          width: '30%',
          key: 'address'
        }
      ],
      dashBoardId: window.localStorage.getItem('dashBoardId'),
      daBoardName: window.localStorage.getItem('boardName'),
      resultNum: 0,
      saveAnotherBoardForm: {},
      saveAnotherBoardDialog: false,
      tableData: [],
      addSingleChartDialog: false,
      options: [],
      addBoardForm: {
        level: '',
        levels: []
      },
      dialogVisible: true,
      formInlineTmp: {},
      formInline: {
      },
      loading: false,
      hide: true,
      chart1NameArray: [],
      chart1DataArray: [],
      buyPeopleCount: 0,
      buyXData: [],
      isOrderD: true,
      isOrderW: false,
      isOrderM: false,
      formline: {},
      myChart1: null,
      rules: {
        name: [
          { required: true, message: '请输入看板名称', trigger: 'blur' }
        ]
      },
      layout: JSON.parse(window.localStorage.getItem('itemLayout')).reverse(),
      newX: 0,
      newY: 0,
      saleXUnit: '',
      itemW: 10,
      itemH: 10,
      figuresArray: JSON.parse(window.localStorage.getItem('itemFigures')).reverse(),
      chartObject: {}, // 单图
      myChartPie: [],
      myChartLine: [],
      myChartZhu: [],
      xNames: [],
      yNames: [],
      xNamePie: '',
      chartDataY: [],
      chartDataX: [],
      chartDataYPie: [],
      addChart: false,
      barWidth: 0,
      boardScale: 80, // 获取右边宽度与里边可以拖动div比例确定里边图的大小
      screenHeight: window.innerWidth, // 屏幕宽度
      typeOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '客户分析',
          value: '1'
        },
        {
          label: '行为分析',
          value: '2'
        },
        {
          label: '漏斗分析',
          value: '3'
        },
        {
          label: '订单分析',
          value: '4'
        },
        {
          label: 'RFM分析',
          value: '5'
        },
        {
          label: '复购分析',
          value: '6'
        }
      ],
      isFirst: true
    }
  },
  computed: {
    ...mapGetters([
      'getLeftmenu'
    ])
  },
  components: {
    GridLayout,
    GridItem,
    ATable: Table,
    ALocaleProvider: LocaleProvider
  },
  watch: {
  },
  updated() {
    this.resize()
  },
  mounted() {
    let self = this
    window.onresize = function windowResize () {
      // 通过捕获系统的onresize事件触发我们需要执行的事件
      // self.screenHeight = window.innerWidth
      self.boardScale = window.innerWidth / 20
      for (var i = 0; i < self.figuresArray.length; i++) {
        let position = []
        if (self.figuresArray[i].position.length !== 0) {
          position = JSON.parse(self.figuresArray[i].position)
        } else {
          position = [0, 0, 6, 4]
        }
        self.resizeDiv(self.figuresArray[i].id, position[2], position[3], '')
      }
    }
  },
  created() {
    this.tmpName = this.myStorage.getItem('boardName')
    this.loading = true
    this.getSingleChartData()
  },
  methods: {
    resize() {
      if (this.isFirst === true) {
        this.boardScale = window.innerWidth / 20
        for (var i = 0; i < this.figuresArray.length; i++) {
          let position = []
          if (this.figuresArray[i].position.length !== 0) {
            // position = JSON.parse(this.figuresArray[i].position)
            let obj = this.figuresArray[i].position
            if (typeof obj =='object' && obj.constructor === Array) {
              position = this.figuresArray[i].position
            } else {
              position = JSON.parse(this.figuresArray[i].position)
            }
          } else {
            position = [0, 0, 6, 4]
          }
          this.figuresArray[i].position = JSON.stringify(position)
          this.resizeDiv(this.figuresArray[i].id, position[2], position[3], '')
        }
        this.isFirst = false
      }
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    deleteDashboardAction(itemId) {
      this.$confirm('确定从当前看板移除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSingleChartFromeDashBoard(this.dashBoardId, itemId).then(res => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.des)
          }
          // this.getData()
        })
      }).catch((error) => {
      })
    },
    // 添加单图跳转客户分析
    addtSingleAction() {
      router.push({ path: '/home/customer-analyse', query: { isAdd: 1 } })
    },
    pushToPage(item) {
      getSingleChartDetails(item.i).then(res => {
        window.localStorage.setItem('itemLayout', JSON.stringify(this.layout))
        window.localStorage.setItem('itemFigures', JSON.stringify(this.figuresArray))
        sessionStorage.setItem('queryJson', res.data.result.filterJson)
        this.myStorage.setItem('borderDetailsIsAdd', 'true')
        if (item.type === 1) {
          router.push({ path: '/home/customer-analyse', query: { id: item.i, name: res.data.result.name, isAdd: 1 } })
        }
        if (item.type === 2) {
          router.push({ path: '/home/behavior-analyse', query: { id: item.i, name: res.data.result.name, isAdd: 1 } })
        }
      })
    },
    // 删除单图
    deleteSingleChart(item) {
      this.$confirm('确认删除该单图?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSingleChartFromeDashBoard(this.dashBoardId, item.figureId).then(res => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.des)
            let length = this.figuresArray.length
            for (let one of this.figuresArray) {
              if (one.id === item.figureId) {
                let index = this.figuresArray.indexOf(one)
                this.figuresArray.splice(index, 1)
              }
            }
            for (let two of this.layout) {
              if (two.i === item.figureId) {
                let index = this.layout.indexOf(two)
                this.layout.splice(index, 1)
              }
            }
            this.myStorage.setItem('itemFigures', JSON.stringify(this.figuresArray))
            this.myStorage.setItem('itemLayout', JSON.stringify(this.layout))
            this.getSingleChartData()
          } else {
            _g.toastMsg('error', res.data.des)
          }
        })
      }).catch((error) => {
      })
    },
    // 暂存单图名字
    saveSingleNameOnly() {
      this.showSingleName = false
      this.modifyTitleAction()
    },
    openEditName() {
      this.showSingleName = true
      this.editSingleName = this.editSingleNameShow
    },
    // 跳转选择单图页面
    confirmSingleAction() {
      // if (this.selectType === 1) {
      window.localStorage.setItem('itemLayout', JSON.stringify(this.layout))
      window.localStorage.setItem('itemFigures', JSON.stringify(this.figuresArray))
      this.myStorage.setItem('borderDetailsIsAdd', 'true')
      router.push({ path: '/home/customer-analyse' })
      // } else {
      //   router.push({ path: '/home/behavior-analyse' })
      // }
    },
    chooseTable(type, item, one) {
      item.showType = type
      one.defaultShow = type
      this.saveDashBoardAction()
    },
    choosePie(type, item, one) {
      item.showType = type
      one.defaultShow = type
      let pieId = 'chartPie' + one.figureId
      let piechart = this.$refs[pieId]
      let chatData = this.chartObject[one.figureId].barLinePieData
      let chartName = this.chartObject[one.figureId].figureName
      let dataY = []
      let dataX = []
      for (let item of chatData.valueList) {
        dataY.push(item.y)
        dataX.push(item.x)
      }
      this.chartPieOne(chartName, chatData.xName, chatData.yName, dataX, dataY, piechart[0])
      this.saveDashBoardAction()
    },
    chooseLine(type, item, one) {
      item.showType = type
      one.defaultShow = type
      let lineId = 'chartLine' + one.figureId
      let linechart = this.$refs[lineId]
      let chatData = this.chartObject[one.figureId].barLinePieData
      let chartName = this.chartObject[one.figureId].figureName
      let dataY = []
      let dataX = []
      for (let item of chatData.valueList) {
        dataY.push(item.y)
        dataX.push(item.x)
      }
      this.chartLineOne(chartName, chatData.xName, chatData.yName, dataX, dataY, linechart[0])
      this.saveDashBoardAction()
    },
    chooseZhu(type, item, one) {
      item.showType = type
      one.defaultShow = type
      let barId = 'barChart' + one.figureId
      let barchart = this.$refs[barId]
      let chatData = this.chartObject[one.figureId].barLinePieData
      let chartName = this.chartObject[one.figureId].figureName
      let dataY = []
      let dataX = []
      for (let item of chatData.valueList) {
        dataY.push(item.y)
        dataX.push(item.x)
      }
      this.chartZhuOne(chartName, chatData.xName, chatData.yName, dataX, dataY, barchart[0])
      this.saveDashBoardAction()
    },
    chooseNum(type, item, one) {
      item.showType = type
      one.defaultShow = type
      this.saveDashBoardAction()
    },
    resizeDiv(i, W, H, type) {
      this.boardScale = window.innerWidth / 20
      let barId = 'barChart' + i
      let barContentId = 'barContent' + i
      let barchart = this.$refs[barId]
      let barContent = this.$refs[barContentId]
      let bar
      if (barchart) {
        bar = this.$echarts.init(barchart[0])
        barchart[0].style.width = (W * this.boardScale) * 12 / 20 + 'px'
        barContent[0].style.width = (W * this.boardScale) * 13 / 20 + 'px'
        bar.resize()
        barchart[0].style.height = (H * this.boardScale) * 10 / 20 + 'px'
        barContent[0].style.height = (H * this.boardScale) * 13 / 20 + 'px'
      }

      let pieId = 'chartPie' + i
      let pieContentId = 'pieContent' + i
      let piechart = this.$refs[pieId]
      let pieContent = this.$refs[pieContentId]
      let pie
      if (piechart) {
        piechart[0].style.width = (W * this.boardScale) * 13 / 20 + 'px'
        pieContent[0].style.width = (W * this.boardScale) * 13 / 20 + 'px'
        pie = this.$echarts.init(piechart[0])
        pie.resize()
        piechart[0].style.height = (H * this.boardScale) * 13 / 20 + 'px'
        pieContent[0].style.height = (H * this.boardScale) * 16 / 20 + 'px'
      }

      let lineId = 'chartLine' + i
      let lineContentId = 'lineContent' + i
      let linechart = this.$refs[lineId]
      let lineContent = this.$refs[lineContentId]
      let line
      if (linechart) {
        linechart[0].style.width = (W * this.boardScale) * 14 / 20 + 'px'
        lineContent[0].style.width = (W * this.boardScale) * 14 / 20 + 'px'
        line = this.$echarts.init(linechart[0])
        linechart[0].style.height = (H * this.boardScale) * 10 / 20 + 'px'
        lineContent[0].style.height = (H * this.boardScale) * 15 / 20 + 'px'
        line.resize()
      }

      let metricId = 'metricContent' + i
      let singleMetric = this.$refs[metricId]
      if (singleMetric) {
        singleMetric[0].style.width = (W * this.boardScale) * 10 / 20 + 'px'
        singleMetric[0].style.height = (H * this.boardScale) * 10 / 20 + 'px'
      }
    },
    modifyTitleAction() {
      let str = this.myStorage.getItem('boardName')
      if (this.daBoardName === str) {
        return
      }
      modifyDashBoardTitle(this.dashBoardId, this.daBoardName).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.des)
          this.myStorage.setItem('boardName', this.daBoardName)
          this.tmpName = this.myStorage.getItem('boardName')
        } else {
          this.daBoardName = this.tmpName
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    submitSaveAnotherBoardForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveDashBoard()
        } else {
          return false
        }
      })
    },
    // 另存看板
    saveDashBoard() {
      saveAnotherDashBoard(this.dashBoardId, this.saveAnotherBoardForm.name).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '另存看板成功')
          this.saveAnotherBoardDialog = false
          // router.push({ path: '/home/board-list' })
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    // 添加单图
    addSingleChartAction() {
      window.localStorage.setItem('itemLayout', JSON.stringify(this.layout))
      window.localStorage.setItem('itemFigures', JSON.stringify(this.figuresArray))
      router.push({ path: '/home/add-single-chart', query: { id: this.dashBoardId } })
    },
    //
    saveDashBoardAction(type) {
      for (let j = 0; j < this.figuresArray.length; j++) {
        for (let i = 0; i < this.layout.length; i++) {
          if (this.layout[i].i === this.figuresArray[j].id) {
            this.figuresArray[j].showType = this.layout[i].showType
          }
        }
      }
      // for (let it of this.figuresArray) {
      //   it.position = JSON.stringify(it.position)
      // }
      updateDashBoard(this.dashBoardId, this.figuresArray).then(res => {
        if (res.data.code === 0) {
          if (type === 1) {
            _g.toastMsg('success', '保存成功')
          }
        } else {
          _g.toastMsg('error', res.data.des)
        }
      })
    },
    readyDiv() {
      for (var j = 0; j < this.figuresArray.length; j++) {
        let position = []
        if (this.figuresArray[j].position.length !== 0) {
          let obj = this.figuresArray[j].position
          if (typeof obj =='object' && obj.constructor === Array) {
            position = this.figuresArray[j].position
          } else {
            position = JSON.parse(this.figuresArray[j].position)
          }
        } else {
          position = [0, 0, 6, 10]
        }
        this.figuresArray[j].position = JSON.stringify(position)
        if (this.figuresArray[j].showType !== '') {
          if (this.figuresArray[j].showType === 'pieChart') {
            let pieId = 'chartPie' + this.figuresArray[j].id
            let piechart = this.$refs[pieId]
            let chatData = this.chartObject[this.figuresArray[j].id].barLinePieData
            let chartName = this.chartObject[this.figuresArray[j].id].figureName
            let dataY = []
            let dataX = []
            for (let item of chatData.valueList) {
              dataY.push(item.y)
              dataX.push(item.x)
            }
            this.resizeDiv(this.figuresArray[j].id, position[2], position[3], '')
            this.xNamePie = chartName
            this.chartPieOne(chartName, chatData.xName, chatData.yName, dataX, dataY, piechart[0])
          } else if (this.figuresArray[j].showType === 'lineChart') {
            let lineId = 'chartLine' + this.figuresArray[j].id
            let linechart = this.$refs[lineId]
            let chatData = this.chartObject[this.figuresArray[j].id].barLinePieData
            let chartName = this.chartObject[this.figuresArray[j].id].figureName
            let dataY = []
            let dataX = []
            for (let item of chatData.valueList) {
              dataY.push(item.y)
              dataX.push(item.x)
            }
            this.xNamePie = chartName
            this.resizeDiv(this.figuresArray[j].id, position[2], position[3], '')
            this.chartLineOne(chartName, chatData.xName, chatData.yName, dataX, dataY, linechart[0])
          } else if (this.figuresArray[j].showType === 'barGraph') {
            let barId = 'barChart' + this.figuresArray[j].id
            let barchart = this.$refs[barId]
            let chatData = this.chartObject[this.figuresArray[j].id].barLinePieData
            let chartName = this.chartObject[this.figuresArray[j].id].figureName
            let dataY = []
            let dataX = []
            for (let item of chatData.valueList) {
              dataY.push(item.y)
              dataX.push(item.x)
            }
            this.xNamePie = chartName
            this.resizeDiv(this.figuresArray[j].id, position[2], position[3], '')
            this.chartZhuOne(chartName, chatData.xName, chatData.yName, dataX, dataY, barchart[0])
          } else if (this.figuresArray[j].showType === 'singleMetric') {
            this.$nextTick(() => {
              this.resizeDiv(this.figuresArray[j].id, position[2], position[3], '')
            })
          }
          // else if (this.figuresArray[j].showType === 'table') {
          // }
        }
        if (this.figuresArray[j].showType === '') {
          if (this.chartObject[this.figuresArray[j].id].defaultShow === 'pieChart') {
            let pieId = 'chartPie' + this.chartObject[j].figureId
            let piechart = this.$refs[pieId]
            let chatData = this.chartObject[this.figuresArray[j].id].barLinePieData
            let chartName = this.chartObject[this.figuresArray[j].id].figureName
            let dataY = []
            let dataX = []
            for (let item of chatData.valueList) {
              dataY.push(item.y)
              dataX.push(item.x)
            }
            this.xNamePie = chartName
            this.chartPieOne(chartName, chatData.xName, chatData.yName, dataX, dataY, piechart[0])
          } else if (this.chartObject[this.figuresArray[j].id].defaultShow === 'lineChart') {
            let lineId = 'chartLine' + this.chartObject[j].figureId
            let linechart = this.$refs[lineId]
            let chatData = this.chartObject[this.figuresArray[j].id].barLinePieData
            let chartName = this.chartObject[this.figuresArray[j].id].figureName
            let dataY = []
            let dataX = []
            for (let item of chatData.valueList) {
              dataY.push(item.y)
              dataX.push(item.x)
            }
            this.xNamePie = chartName
            this.chartLineOne(chartName, chatData.xName, chatData.yName, dataX, dataY, linechart[0])
          } else if (this.chartObject[this.figuresArray[j].id].defaultShow === 'barGraph') {
            let barId = 'barChart' + this.chartObject[j].figureId
            let barchart = this.$refs[barId]
            let chatData = this.chartObject[this.chartObject[j].figureId].barLinePieData
            let chartName = this.chartObject[this.figuresArray[j].id].figureName
            let dataY = []
            let dataX = []
            for (let item of chatData.valueList) {
              dataY.push(item.y)
              dataX.push(item.x)
            }
            this.chartZhuOne(chartName, chatData.xName, chatData.yName, dataX, dataY, barchart[0])
          } else if (this.chartObject[this.figuresArray[j].id].defaultShow === 'singleMetric') {
            this.resizeDiv(this.figuresArray[j].id, position[2], position[3], '')
          }
          // else if (this.chartObject[this.figuresArray[j].id].defaultShow === 'table') {
          // }
        }
      }
      // window.innerWidth = window.innerWidth
    },
    getSingleChartData() {
      let requestArr = []
      let resCount = 0
      let obj = {}
      for (var i = 0; i < this.figuresArray.length; i++) {
        requestArr[i] = getSingleChartDashBoard(this.figuresArray[i].id)
        requestArr[i].then(res => {
          resCount += 1
          if (res.data.code === '200') {
            obj[res.data.result.figureId] = res.data.result
            if (resCount === this.figuresArray.length) {
              this.loading = false
              this.chartObject = obj
              this.$nextTick(() => {
                this.readyDiv()
              })
            }
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }
    },
    // 柱状图
    chartZhuOne(title, xNames, yNames, chartDataX, chartDataY, item) {
      let chart = this.$echarts.init(item)
      if (chartDataX.length <= 10) {
        this.barWidth = '20%'
      }
      if (chartDataX.length > 10) {
        this.barWidth = '20%'
      }
      chart.setOption({
        title: {
          text: '',
          textStyle: {
            color: '#666',
            fontWeight: '',
            fontSize: '16'
          },
          x: 10,
          y: 10
        },
        color: ['#1980FF'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '4%',
          right: '22%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: chartDataX,
            axisTick: {
              alignWithLabel: true
            },
            name: xNames
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: yNames
          }
        ],
        series: [
          {
            name: yNames,
            type: 'bar',
            barWidth: this.barWidth,
            data: chartDataY
            // itemStyle: {
            //   normal: {
            //     color: chart.graphic.LinearGradient(0, 0, 0, 1,[
            //         { offset: 0, color: '#83bff6' },
            //         { offset: 0.5, color: '#188df0' },
            //         { offset: 1, color: '#188df0' }
            //       ]
            //     )
            //   },
            //   emphasis: {
            //     color: this.$echarts.init(item).graphic.LinearGradient(
            //       0, 0, 0, 1,
            //       [
            //         {offset: 0, color: '#2378f7'},
            //         {offset: 0.7, color: '#2378f7'},
            //         {offset: 1, color: '#83bff6'}
            //       ]
            //     )
            //   }
            // }
          }
        ]
      }, false, false)
    },
    // 饼图
    chartPieOne(title, xNames, yNames, chartDataX, chartDataY, item) {
      let array = []
      for (let i = 0; i < chartDataX.length; i++) {
        array.push({
          name: chartDataX[i],
          value: chartDataY[i]
        })
      }
      let chart = this.$echarts.init(item)
      chart.setOption({
        title: {
          text: '',
          textStyle: {
            color: '#666',
            fontWeight: '',
            fontSize: '16'
          },
          x: 10,
          y: 10
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 20,
          top: 20,
          bottom: 20,
          data: chartDataX
        },
        series: [
          {
            name: title,
            type: 'pie',
            radius: ['50%', '65%'],
            // data: chartDataY,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'outside'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '20',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              color: function(params) {
                var colorList = ['#f5be00', '#00ffb4', '#ff2797', '#9f45fb', '#00f5f2', '#ff4949', '#2cff27', '#fd932b', '#ff5fdf', '#4c61fe', '#ed661c', '#45b0fb', '#3400f5', '#ff8c8c', '#ff2797', '＃acbf5d', '#62bba1', '#80ba4d', '#254fa3', '#fbda78', '#3e9389', '#843583', '#64daff', '#9bc1de', '#7b9df9', '#9ab899', '#fcceac', '#e94b63', '#f073ab',  '#6d8345',  '#9c95c9', '#cd9a5b', '#decc00', '#d4c59e', '#7d5786', '#95d6da', '#018792', '#b44333', '#d68989', '#fece7a']
                return colorList[params.dataIndex]
              }
            },
            data: array
          }
        ]
      }, false, false)
    },
    // 折线图
    chartLineOne(title, xNames, yNames, chartDataX, chartDataY, item) {
      let chart = this.$echarts.init(item)
      chart.setOption({
        title: {
          text: '',
          textStyle: {
            color: '#666',
            fontWeight: '',
            fontSize: '16'
          },
          x: 10,
          y: 10
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '4%',
          right: '19%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: chartDataX,
          name: xNames
        },
        yAxis: {
          type: 'value',
          name: yNames
        },
        series: [{
          data: chartDataY,
          type: 'line',
          lineStyle: {
            color: '#1980FF'
          },
          areaStyle: {
            normal: {
              color: '#1980FF'
            },
            color: '#CCE3FF'
          }
        }]
      }, false, false)
    },
    ...mapMutations([
      'setLeftmenu'
    ]),
    moveEvent: function(i, newX, newY, e) {
    },
    resizeEvent: function(i, newH, newW) {
      for (let it = 0; it < this.figuresArray.length; it++) {
        if (this.figuresArray[it].id === i) {
          let array = []
          let posArr = []
          if (this.figuresArray[it].position.length !== 0) {
            let obj = this.figuresArray[it].position
            if (typeof obj =='object' && obj.constructor === Array) {
              posArr = this.figuresArray[it].position
            } else {
              posArr = JSON.parse(this.figuresArray[it].position)
            }
            array = [posArr[0], posArr[1], newW, newH]
          } else {
            array = [0, 0, newW, newH]
          }
          this.figuresArray[it].position = JSON.stringify(array)
        }
      }
      this.saveDashBoardAction()
      this.resizeDiv(i, newW, newH, 1)
    },
    movedEvent: function(i, newX, newY, e) {
      for (let its = 0; its < this.figuresArray.length; its++) {
        if (this.figuresArray[its].id === i) {
          let array = []
          let posArr = []
          if (this.figuresArray[its].position.length !== 0) {
            let obj = this.figuresArray[its].position
            if (typeof obj =='object' && obj.constructor === Array) {
              posArr = this.figuresArray[its].position
            } else {
              posArr = JSON.parse(this.figuresArray[its].position)
            }
            array = [newX, newY, posArr[2], posArr[3]]
          } else {
            array = [newX, newY, 6, 4]
          }
          this.figuresArray[its].position = JSON.stringify(array)
        }
      }
      this.saveDashBoardAction()
    },
    resizedEvent: function(i, newH, newW, newHPx, newWPx) {
    }
  }
}
</script>
<style scoped>
.inspiration {
  margin-top: 20px;
  background: #fff;
  width: calc(100% - 40px);
  height: auto;
  overflow: auto;
  background-color: #fff;
}
.middle {
  /*background-color: #dedede;*/
  /*height: 1900px;*/
  width: 100%;
  /*overflow: auto;*/
}
.false-footer {
  width: 100%;
  font-size: 12px;
  color: #999;
  margin: 0 auto 0;
}
.vue-grid-layout {
  position: relative;
  width: 100%;
  height: 100%;
}
.vue-grid-layout>div {
   position: relative;
   background: #fff;
   height: 90%;
   width: 90%;
}
.chart1 {
  position: relative;
  width: 562px;
  height: 240px;
  background: #fff;
  margin: 0 auto;
}
.chart1>div {
  position: relative;
  width: 562px;
  height: 240px;
  background: #fff;
  overflow: auto;
}
.chart-content::-webkit-scrollbar {
  width: 8px;
  height: 6px;
  background-color: #F5F5F5;
}
.right {
  width: 370px;
}
.chart-content {
  overflow: hidden;
  border-top: 0px;
  position: relative;
  width: 100%;
  height: 100%;
}
/*.chart-content:hover {
  overflow: scroll;
}*/
.text-align-right {
  text-align: right;
  font-size: 30px;
}
.text-align-right .analyse-icon {
  float: right;
  cursor: pointer;
  margin: 8px 5px!important;
  font-size: 14px!important;
  color: #666!important;
}
.text-align-right .dropdown-icon {
  font-size: 1px!important;
  width: 10px!important;
  height: 10px!important;
  color: #666!important;
}
.chart-title {
  width: 150px;
  font-size: 14px;
  text-align: left;
  font-weight: bold;
  float: left;
  color: #666;
  margin: 10px 10px 10px 10px;
}
.table-div {
  width: 100%;
  overflow: auto;
  height: 100%;
  background-color: #fff;
}
.result-number {
  width: 100%!important;
  height: 100%!important;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.result-number span {
  font-size: 44px;
  color: #1980FF;
  width: 100%;
  font-weight: 500;
}
.el-dialog__body {
  padding-top: 0px!important;
}
.el-form-item__label {
  margin-left: 0px!important;
}
.add-div {
  cursor: pointer;
  color: #1980FF;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  /*font-size: 25px;
  display: block;
  margin-top: 10px;
  color: #333;
  margin-right: 10px;*/
}
.dropdown-icon {
  font-size: 25px;
}
.item-content:hover .button-content {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
.button-content {
  display: none;
}
</style>
